(ns ui.view.card.value-creations.sub
  (:require 
   [re-frame.core :as rf]
   [ui.state.session.sub :as session-sub]
   [ui.view.card.entity-list.util :as entity-list-util]
   [ui.view.card.sub :as common-sub]))

(defn value-creations? [entity]
  (= (:entity/type entity) :entity.type/value-creation))

(rf/reg-sub
 ::value-creations
 (fn [[_ ctx]]
   [(rf/subscribe [::common-sub/entities ctx])])
 (fn [[card-entities-by-id] [_ ctx]]
   (let [primary-entity-id (:entity-id ctx)
         value-creations (->> card-entities-by-id
                   vals
                   (filterv (fn [entity]
                              (and (value-creations? entity)
                                   (some #{primary-entity-id}
                                         (:common/related-entities entity))))))]
     value-creations)))

(rf/reg-sub
 ::value-creations-count
 (fn [[_ ctx]]
   [(rf/subscribe [::value-creations ctx])])
 (fn [[value-creations]]
   (count value-creations)))

(rf/reg-sub
 ::table-data
 (fn [[_ ctx]]
   [(rf/subscribe [::value-creations ctx])
    (rf/subscribe [::common-sub/entities ctx])
    (rf/subscribe [::session-sub/entities])
    (rf/subscribe [::session-sub/tenant])
    (rf/subscribe [::session-sub/tenant-schema])])
 (fn [[value-creations
       card-entities-by-id
       global-entities-by-id
       tenant
       tenant-schema]
      [_ {:keys [card] :as _ctx}]]
   (let [all-entities-by-id (merge global-entities-by-id card-entities-by-id)
         column-fields (->> card
                            :card/config
                            :table
                            :columns
                            (mapv :field))]
     
          (entity-list-util/entities->table-row-data
           {:entities value-creations
            :column-fields column-fields
            :entities-by-id all-entities-by-id
            :tenant tenant
            :tenant-schema tenant-schema}))))

